/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { Navbar } from "../../components/navbar";
import "./styles.scss";
import { Dropdown } from "../../components/contactDropdownMenu"
import { timeForAction_OPTIONS } from "../../common/constant";
import closeIcon from "../../assets/icons/upload.png"
import { FileUploader } from "react-drag-drop-files";

export const OffersPage: React.FC = () => {
    const [selectedOption, setSelectedOption] = useState<string>("");
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [file, setFile] = useState<any>()
    const fileTypes = ["JPEG", "PNG", "GIF"];
    const options = [
        timeForAction_OPTIONS.message1,
        timeForAction_OPTIONS.message2,
        timeForAction_OPTIONS.message3,
        timeForAction_OPTIONS.message4,
        timeForAction_OPTIONS.message5,
        timeForAction_OPTIONS.message6,
        timeForAction_OPTIONS.message7,
        timeForAction_OPTIONS.message8,
    ];
    const handlechange = (file: any) => {
        console.log("submitted");
        setFile(file);
    }

    return (
        <>
            <Navbar />
            <div className="offer-page">
                <div className="heading">
                    <h1>Number of Successful Parking Hero Missions</h1>
                </div>
                <div className="space"></div>
                <div className="space"></div>
                <div className="dropdown">
                    <Dropdown isOpen={isOpen} setIsOpen={setIsOpen} selectedOption={selectedOption} setSelectedOption={setSelectedOption} options={options} />
                </div>
                <div className="space"></div>
                <div className="hidden-container">
                    <div className="containers important">
                        <div className="items drag-area">
                            <FileUploader
                                multiple={true}
                                handleChange={handlechange}
                                name="file"
                                types={fileTypes}
                                
                            >
                                <div className="close">
                                    <div className="btn-close" >
                                        <img src={closeIcon} alt="not-found"/>
                                    </div>
                                </div>
                                <p className="description">Drag your file here</p>
                                <p className="or">or</p>
                                <button className="btns">Browse</button>
                            </FileUploader>
                        </div>
                    </div>
                    {file &&
                        <div>
                            <button className="btn"
                                disabled={file ? false : true}
                                style={!file ? { cursor: "not-allowed" } : { cursor: "pointer" }}
                            >submit</button>
                        </div>
                    }
                </div>
            </div>
        </>
    )
}
